import "./App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import MainLayout from "./components/layout/MainLayout";
import HomePage from "./components/pages/HomePage";
import LoginPage from "./components/auth/LoginPage";
import RegisterPage from "./components/auth/RegisterPage";
import CoursesPage from "./components/pages/CoursesPage";
import PracticeRoomPage from "./components/pages/PracticeRoomPage";
import ExamInfoPage from "./components/pages/ExamInfoPage";
import ExamTestPage from "./components/pages/Exam/ExamTest/ExamTestPage";
import MaterialsPage from "./components/pages/Materials/MaterialsPage";
import MaterialDetailPage from "./components/pages/Materials/MaterialDetailPage";
import ExamResultPage from "./components/pages/Exam/ExamResult/ExamResultPage";
import ExamAnswerPage from "./components/pages/Exam/ExamAnswer/ExamAnswerPage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* Public Layout with Header and Footer */}
      <Route element={<PublicRoute />}></Route>
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/practice-room" element={<PracticeRoomPage />} />
        <Route path="/mock-test" element={<div>Mock Test</div>} />
        <Route path="/materials" element={<MaterialsPage />} />
        <Route path="/materials/:documentId" element={<MaterialDetailPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/exam-result/:examId" element={<ExamResultPage />} />
      </Route>

      {/* Private Routes - Authenticated users */}
      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/exam/:examId" element={<ExamInfoPage />} />
        </Route>
        <Route path="/exam-test/:id" element={<ExamTestPage />} />
        <Route path="/exam-answer/:examId" element={<ExamAnswerPage />} />
      </Route>

      {/* Public Routes - Non-authenticated users */}
    </Route>
  )
);
function App() {
  return (
    <div className="App">
      {/* <FallingLeaves /> */}
      {/* <ParticleBackground /> */}
      <RouterProvider router={router} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
